// extracted by mini-css-extract-plugin
export var noSpinners = "_n8-6";
export var percentageInput = "_n8-7";
export var variantColor1 = "_n8-0";
export var variantColor2 = "_n8-1";
export var variantColor3 = "_n8-2";
export var variantColor4 = "_n8-3";
export var variantColor5 = "_n8-4";
export var variantColor6 = "_n8-5";